import { render, staticRenderFns } from "./ViewTransition.vue?vue&type=template&id=1a2b9c50&"
import script from "./ViewTransition.vue?vue&type=script&lang=js&"
export * from "./ViewTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports